export const SET_SCHOOL_APPOINTMENT_ID = 'SET_SCHOOL_APPOINTMENT_ID';
export const SET_SCHOOL_DATE = 'SET_SCHOOL_DATE';
export const SET_SCHOOL_TIME = 'SET_SCHOOL_TIME';
export const SET_SCHOOL_SESSIONS_PER_WEEK = 'SET_SCHOOL_SESSIONS_PER_WEEK';
export const SET_SCHOOL_SESSION_TYPE = 'SET_SCHOOL_SESSION_TYPE';
export const SET_SCHOOL_REPEAT = 'SET_SCHOOL_REPEAT';
export const SET_SCHOOL_SUBJECT_ID = 'SET_SCHOOL_SUBJECT_ID';
export const SET_SCHOOL_APPOINTMENT_TYPE = 'SET_SCHOOL_APPOINTMENT_TYPE';
export const SET_SCHOOL_JOB_VALUE = 'SET_SCHOOL_JOB_VALUE';
export const SET_SCHOOL_SELECTED_STUDENT = 'SET_SCHOOL_SELECTED_STUDENT';
export const SCHOOL_RESET_APPOINTMENT_STATE = 'SCHOOL_RESET_APPOINTMENT_STATE';
export const SET_SCHOOL_DURATION = 'SET_SCHOOL_DURATION';



